import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

export default class extends Controller {
  connect() {
    // Initialize tooltips on all buttons
    this.initializeTooltips()
  }

  initializeTooltips() {
    // Use jQuery for Bootstrap 4.5.2 tooltip initialization
    try {
      if (typeof $ !== 'undefined') {
        $(this.element).find('[data-toggle="tooltip"]').tooltip({
          container: 'body'
        })
      } else if (bootstrap && bootstrap.Tooltip) {
        // Fallback to direct Bootstrap if jQuery isn't available
        const tooltips = this.element.querySelectorAll('[data-toggle="tooltip"]')
        tooltips.forEach(tooltip => {
          new bootstrap.Tooltip(tooltip)
        })
      }
    } catch (e) {
      console.error('Error initializing tooltips:', e)
    }
  }

  // Keep dropdown open when clicking inside, unless it's a link
  click(event) {
    if (!event.target.closest('a')) {
      event.stopPropagation()
    }
  }
}
